import axios from "axios";
import { API_ENDPOINT, API_ENDPOINT_NODE } from "../config/config";
import TokenService from "./token.service";

const axiosInstance = axios.create({
  baseURL: API_ENDPOINT_NODE,
  headers: {
    "Content-Type": "application/json",
  },
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((p) => (error ? p.reject(error) : p.resolve(token)));
  failedQueue = [];
};

axiosInstance.interceptors.request.use(
  (config) => {
    const authTokens = TokenService.getUser();
    if (authTokens?.tokens?.access) {
      config.headers["Authorization"] = `Bearer ${authTokens.tokens.access}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config;

    if (
      originalConfig.url !== `${API_ENDPOINT}Account/Authorize` &&
      err.response
    ) {
      if (err.response.status === 403 && !originalConfig._retry) {
        originalConfig._retry = true;

        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              if (token) {
                originalConfig.headers["Authorization"] = `Bearer ${token}`;
              } else {
                delete originalConfig.headers["Authorization"];
              }
              return axiosInstance(originalConfig);
            })
            .catch(() => Promise.reject(err));
        }

        isRefreshing = true;
        const authTokens = TokenService.getUser();

        try {
          const response = await axios.post(
            `${API_ENDPOINT}token/refresh/`,
            { refresh: authTokens?.tokens?.refresh }
          );

          const newToken = response.data?.access;
          TokenService.updateLocalAccessToken(newToken);
          processQueue(null, newToken);

          originalConfig.headers["Authorization"] = `Bearer ${newToken}`;
          return axiosInstance(originalConfig);
        } catch (refreshError) {
          processQueue(refreshError, null);
          TokenService.removeUser();
          window.location.href = "/";
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }

      if (err.response.status === 401) {
        TokenService.removeUser();
        window.location.href = "/";
        return Promise.reject(err.response.data);
      }
    }

    return Promise.reject(err);
  }
);

export default axiosInstance;
